import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { SafeUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { AppScopes } from 'app/core/authentication/models/scopes.enum';
import { AuthService } from 'app/core/authentication/services';
import { UserInterface } from 'app/core/user/models';
import { NameLinkOptions } from 'app/shared/components/user-name-link/user-name-link.component';
import { LicenseDataInterface } from 'app/site-settings/models/license-data.model';
import { SiteSettingsService } from 'app/site-settings/services/site-settings.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'cz-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})

export class HeaderComponent {

  @Input() public user$: BehaviorSubject<UserInterface>;
  @Input() public isDefaultUser: boolean;
  public numberOfDays:number;
  public canCreateTask: boolean;
  public isAdminMaster: boolean;
  public adminToken: SafeUrl;
  public alert1: any;
  public displayLicence:boolean = false;
  public licenseConditionDays: number = 15;
  public badgeConfig: NameLinkOptions = {
    showBadge: true,
    badgeOnRight: true,
    showLogout: true,
    showUserName: false,
    linkToProfile: true,
  };
  public licenseData$: BehaviorSubject<LicenseDataInterface>;

  private destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(public readonly dialog: MatDialog,
              private _siteSettingsService: SiteSettingsService,
              private _translateService: TranslateService,
              private readonly _authService: AuthService) {
    this._authService.isLoggedInUserAuthorized(
      [
        AppScopes.CASE_MANAGEMENT_MASTER,
        AppScopes.ERGO_WORKFLOW,
      ])
        .pipe(take(1))
        .subscribe((isAuthorized: boolean) => {
          this.canCreateTask = isAuthorized;
        });

    this._authService.isLoggedInUserAuthorized(
      [
        AppScopes.ADMIN,
      ])
      .pipe(take(1))
      .subscribe((isAuthorized: boolean) => {
        this.isAdminMaster = isAuthorized;
      });

    this._siteSettingsService.loadSiteLicesnse()
      .pipe(takeUntil(this.destroy$))
      .subscribe((licenseData: LicenseDataInterface) => {
        if (!licenseData) { return; }
        this.numberOfDays = licenseData.licenseDaysToExpire;
        if (this.numberOfDays <= this.licenseConditionDays && this.isAdminMaster) {
          this.displayLicence = true;
        }

        if(this.numberOfDays===1 && this.isAdminMaster) {
          this.alert1 = this._translateService.instant('$lng_license_alert2');
        } else if(this.numberOfDays<=15 && this.isAdminMaster) {
          this.alert1 = this._translateService.instant('$lng_license_alert1') +' '+
          this.numberOfDays+' '+ this._translateService.instant('$lng_license_alert1a');
        }
      });
  }
  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
